import type { SVGProps } from 'react';
const SvgBorderHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#border_horizontal_svg__a)">
      <path
        fill="currentColor"
        d="M3 21h2v-2H3v2ZM5 7H3v2h2V7ZM3 17h2v-2H3v2Zm4 4h2v-2H7v2ZM5 3H3v2h2V3Zm4 0H7v2h2V3Zm8 0h-2v2h2V3Zm-4 4h-2v2h2V7Zm0-4h-2v2h2V3Zm6 14h2v-2h-2v2Zm-8 4h2v-2h-2v2Zm-8-8h18v-2H3v2ZM19 3v2h2V3h-2Zm0 6h2V7h-2v2Zm-8 8h2v-2h-2v2Zm4 4h2v-2h-2v2Zm4 0h2v-2h-2v2Z"
      />
    </g>
    <defs>
      <clipPath id="border_horizontal_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBorderHorizontal;
